(function () {
  function currentTheme() {
    return document.documentElement.getAttribute('data-theme') === 'light' ? 'light' : 'dark';
  }

  function apply(theme) {
    if (theme === 'light') {
      document.documentElement.setAttribute('data-theme', 'light');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
    document.querySelectorAll('[data-vtk-theme-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', theme === 'light' ? 'true' : 'false');
      var nextLabel = theme === 'light' ? btn.dataset.labelToDark : btn.dataset.labelToLight;
      if (nextLabel) btn.setAttribute('aria-label', nextLabel);
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-vtk-theme-toggle]');
    if (!btn) return;
    var next = currentTheme() === 'light' ? 'dark' : 'light';
    try {
      localStorage.setItem('vtk-theme', next);
    } catch (e) {}
    apply(next);
  });

  document.addEventListener('DOMContentLoaded', function () {
    apply(currentTheme());
  });
})();
